var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRequest } from '../../../hooks/requestHook';
import { shippingInstruction as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { FormikTextField } from '../../atoms/TextField';
import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import { camelize } from '../../../utils/camelize';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import OfferSelect from '../../organisms/OfferSelect';
import { FormikSelectField } from '../../atoms/SelectField';
import { packages } from '../../../constants/offerValues';
var ShippingInstructionForm = function (_a) {
    var shippingInstruction = _a.shippingInstruction, onCreated = _a.onCreated;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var create = useRequest(api.createItem);
    var _c = React.useState(), offer = _c[0], setOffer = _c[1];
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!offer)
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, create({
                            shipping_instruction_item: __assign({ shipping_instruction_id: shippingInstruction.id, offer_id: offer.id }, values),
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onCreated(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, shippingInstruction, offer, create, notify, onCreated]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        fieldsDefinitions
            .filter(function (_a) {
            var required = _a.required;
            return required;
        })
            .forEach(function (_a) {
            var field = _a.field, type = _a.type;
            if (type === 'number') {
                if (Number(values[field]) <= 0) {
                    errors[field] = t('errors.positive', {
                        field: t("params.shippingInstructionItem.".concat(camelize(field))),
                    });
                }
            }
            else {
                if (!values[field] || values[field] === '') {
                    errors[field] = t('errors.isRequired', {
                        field: t("params.shippingInstructionItem.".concat(camelize(field))),
                    });
                }
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: {
            lot_number: '',
            lot_ref: '',
            product_name: '',
            bag_size: '0',
            quantity: 0,
            net_weight: '0',
            fob_price: '0',
            package: 'grainpro',
        },
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: true,
        validateOnChange: true,
    });
    var handleSelectOffer = React.useCallback(function (offer) {
        setOffer(offer);
        if (offer === undefined) {
            formik.setValues(formik.initialValues);
        }
        else {
            formik.setValues({
                lot_number: offer.lotNumber,
                lot_ref: offer.lotRef,
                product_name: '',
                bag_size: offer.bagSize,
                quantity: 0,
                net_weight: '0',
                fob_price: offer.fobPrice,
                package: offer.package,
            });
        }
    }, [formik]);
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 1, marginY: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(OfferSelect, { query: {
                        offer_list_producer_id_eq: shippingInstruction.producer.id,
                    }, value: offer, onChange: handleSelectOffer })),
            fieldsDefinitions.map(function (_a) {
                var field = _a.field, type = _a.type, required = _a.required, items = _a.items;
                return (React.createElement(Grid, { key: field, item: true, xs: 12 }, type === 'select' ? (React.createElement(FormikSelectField, { fullWidth: true, required: required, label: t("params.shippingInstructionItem.".concat(camelize(field))), name: field, items: items, disabled: !offer, formik: formik })) : (React.createElement(FormikTextField, { fullWidth: true, required: required, type: type, label: t("params.shippingInstructionItem.".concat(camelize(field))), name: field, disabled: !offer, formik: formik }))));
            }),
            React.createElement(Grid, { item: true, xs: 12 })),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading }, t('buttons.create'))))));
};
export default ShippingInstructionForm;
var packageItems = Object.entries(packages).map(function (_a) {
    var value = _a[0], text = _a[1];
    return ({
        value: value,
        text: text,
    });
});
var fieldsDefinitions = [
    { field: 'lot_number', required: true, type: 'text' },
    { field: 'lot_ref', required: false, type: 'text' },
    { field: 'product_name', required: true, type: 'text' },
    { field: 'bag_size', required: true, type: 'number' },
    { field: 'quantity', required: true, type: 'number' },
    { field: 'net_weight', required: true, type: 'number' },
    { field: 'package', required: true, type: 'select', items: packageItems },
];
